/* eslint-disable */

import React from "react";

import {
  ScreenHeader,
  Container,
} from "../../components/wombat-ui";
import { H3, H4, P, UList } from "../../components/wombat-ui/components/Typography";

const TermsAndConditions = () => {
  return (
    <>
      <ScreenHeader
      narrow
        title={"Conditions générales d'utilisation du service Mooveo"}
      />
      <Container narrow>
        <P>
          Les présentes Conditions Générales d'Utilisation (ci-après les «
          Conditions d'Utilisation » ou « CGU ») régissent les rapports entre la
          société MOOVEO (ci-après la « Société »), d'une part, et les
          Utilisateurs du Service, ci-après désignés individuellement ou
          collectivement « L'Utilisateur » ou « Les Utilisateurs », d'autre
          part, lors de l'utilisation de la plateforme MOOVEO, ci-après désignée
          le « Service ». Toute personne souhaitant utiliser le Service doit
          avoir pris connaissance préalablement de ces Conditions Générales
          d'Utilisation et s'engage à les respecter sans réserve.
        </P>

        <H3>
          Conditions d'accès et utilisation du Service
        </H3>

        <P>
          Pour faire usage du Service, l'Utilisateur doit avoir atteint l'âge de
          la majorité légale et/ou avoir la capacité pour conclure un contrat au
          sens de la loi, et avoir accepté les présentes Conditions Générales
          d'Utilisation sans aucune réserve.
        </P>

        <P>
          Afin de bénéficier du Service, l'Utilisateur devra au préalable
          s'inscrire en remplissant le formulaire d'inscription, accessible en
          ligne sur le site. En remplissant ce formulaire, l'Utilisateur
          confirme avoir pris connaissance des présentes Conditions
          d'Utilisation et accepter de s'y soumettre sans réserve.
        </P>

        <P>L'Utilisateur s'engage à :</P>

        <UList
          items={[
            "s'inscrire sous sa véritable identité, avec une adresse email valide ;",
            "prévenir immédiatement le Service dans le cas d'une utilisation abusive de son compte ou dans le cas de toute autre entrave à la sécurité.",
          ]}
        />

        <P>
          La Société ne saurait en aucun cas être tenue responsable pour quelque
          perte ou dommage liés à une erreur de manipulation de l'Utilisateur.
        </P>

        <P>
          En remplissant le formulaire d'inscription, l'Utilisateur garantit à
          la Société avoir fourni des informations exactes, à jour et complètes
          concernant son identité et ses coordonnées. Il s'engage notamment à
          fournir une adresse électronique effective et dont il est
          propriétaire.
        </P>

        <P>
          D'une manière générale, l'Utilisateur s'interdit, dans le cadre de
          l'utilisation du Service, de se livrer à des actes tels que
          l'émission, l'édition, la mise en ligne ou la diffusion de données
          et/ou de contenus qui seraient contraires à la loi, porteraient
          atteinte à l'ordre public, ou aux droits de la Société ou de tiers
          ayants-droits.
        </P>

        <P>
          En particulier, sans que cette liste soit limitative, l'Utilisateur
          s'engage, dans son utilisation du Service, à respecter les règles
          suivantes : communiquer des informations exactes lors de son
          inscription et de l'utilisation du Service ; ne pas utiliser de fausse
          identité en vue de tromper autrui ; se conformer aux lois en vigueur
          et respecter les droits des tiers, ainsi que les présentes
          stipulations contractuelles ; utiliser le Service de manière loyale et
          conformément aux dispositions légales, réglementaires et aux usages en
          vigueur ; respecter les droits de propriété intellectuelle afférents
          aux contenus fournis par la Société et par les autres Utilisateurs,
          ainsi que les droits de propriété intellectuelle des tiers ; par
          suite, chaque Utilisateur s'interdit de reproduire et/ou communiquer
          au public, par l'intermédiaire du Service, un ou plusieurs contenus
          sans l'autorisation des titulaires des droits afférents à ces
          contenus, lorsqu'elle est requise ; ne pas détourner ou tenter de
          détourner l'une quelconque des fonctionnalités du Service hors de son
          usage normal tel que défini aux présentes; ne pas utiliser, pour
          naviguer sur le site, un logiciel robot ou tout autre procédé ou outil
          automatisé équivalent ; s'engager à ne communiquer à la Société et aux
          autres Utilisateurs que les informations dont il considère que la
          diffusion ne peut en aucun cas être préjudiciable ni à lui-même, ni
          aux autres Utilisateurs, ni à la Société, ni aux tiers ; ne pas
          diffuser des données, informations ou contenus à caractère
          diffamatoire, injurieux, obscène, offensant, violent ou incitant à la
          violence, ou à caractère politique, raciste ou xénophobe et de manière
          générale tout contenu qui serait contraire aux lois et règlements en
          vigueur ou aux bonnes mœurs ; ne pas diffuser des données,
          informations ou contenus ayant pour effet de diminuer, de
          désorganiser, d'empêcher l'utilisation normale du Service, ou
          d'interrompre et/ou de ralentir la circulation normale des
          communications entre les Utilisateurs.
        </P>

        <P>
          En cas de manquement par l'Utilisateur à l'une ou plusieurs de ces
          règles, la Société se réserve le droit de suspendre et/ou, de bloquer
          le(s) compte(s) de l'Utilisateur concerné, de supprimer
          automatiquement les messages litigieux, d'empêcher la publication de
          tout ou partie du profil, et/ou de bloquer son accès à tout ou partie
          du Service, de façon temporaire ou définitive, sans aucune
          contrepartie.
        </P>

        <H3>
          Accès au service
        </H3>

        <P>
          La Société s'efforce de permettre l'accès au Service 24 heures sur 24,
          7 jours sur 7, sauf en cas de force majeure ou d'un événement hors du
          contrôle de la Société, et sous réserve des éventuelles pannes et
          interventions de maintenance nécessaires au bon fonctionnement du site
          et des services.
        </P>

        <P>
          Par conséquent, la Société ne peut garantir une disponibilité du
          Service, une fiabilité des transmissions et des performances en termes
          de temps de réponse ou de qualité.
        </P>

        <P>
          Il appartient à l'Utilisateur de prendre toutes les mesures
          nécessaires de façon à protéger ses propres données et logiciels de la
          contamination par des éventuels virus circulant à travers le Service.
        </P>
        <P>
          Les équipements permettant l'accès au Service sont à la charge
          exclusive de l'Utilisateur, de même que les frais de
          télécommunications induits par leur utilisation.
        </P>

        <P>
          L'identifiant, les clés publiques et privées permettent à
          l'Utilisateur d'accéder aux fonctionnalités du Service.
        </P>

        <P>
          L'identifiant et les clés publiques et privées sont personnels et
          confidentiels. Ils ne peuvent être utilisés que par l'Utilisateur.
          L'utilisation de l'identifiant et des clés publiques et privées se
          fait sous son entière responsabilité.
        </P>

        <P>
          Tous matériels et logiciels nécessaires à l'accès et à l'utilisation
          du Service restent exclusivement à la charge de l'Utilisateur. Il lui
          appartient de prendre toutes mesures appropriées de façon à protéger
          ses propres données, systèmes informatiques et/ou logiciels de la
          contamination par d'éventuels virus.
        </P>

        <P>
          L'usage des informations, messages ou données de toute nature,
          disponibles par l'intermédiaire du Service relève de la seule
          responsabilité de l'Utilisateur.
        </P>

        <P>
          L'Utilisateur est responsable de toutes données et informations le
          concernant qu'il a mis en ligne ainsi que de tout contenu qu'il a
          fourni.
        </P>

        <P>
          L'Utilisateur s'engage à utiliser exclusivement les clés publiques et
          privées qui lui ont été délivrées. Toute tentative d'accès par des
          clés publiques et privées différentes de celles délivrées est
          considérée comme une agression informatique relevant des lois en
          vigueur.
        </P>

        <P>
          En cas de tentatives réitérées par l'Utilisateur d'accès au Service et
          à ses fonctionnalités, par des clés publiques et privées différentes
          de celles qui ont été délivrées, la Société se réserve le droit
          d'interdire à l'Utilisateur l'accès au Service.
        </P>

        <H3>
          Propriété intellectuelle - Droit à l'image
        </H3>

        <P>
          Le Service ainsi que les textes, marques, graphiques, images, sons et
          vidéos la composant, sont la propriété de tiers ayants-droits et/ou de
          la Société. Toute représentation et/ou reproduction et/ou exploitation
          partielle ou totale des contenus et services proposés par quelque
          procédé que ce soit, sans l'autorisation préalable et par écrit de
          tiers ayants droits et/ou de la Société est strictement interdite et
          serait susceptible de constituer une contrefaçon au sens des articles
          L 335-2 et suivants du Code de la propriété intellectuelle.
        </P>

        <P>
          Il est concédé aux Utilisateurs du Service la possibilité de
          visualiser le contenu du site à titre personnel et privé. L'impression
          papier est autorisée uniquement pour la copie privée à l'usage
          exclusif du copiste au sens de l'article L.122-5-2° du Code de la
          Propriété Intellectuelle.
        </P>

        <P>
          La Société ou des tiers ayants droits sont propriétaires du Service,
          tant dans ses composantes techniques que graphiques, textuelles ou
          autres, sous la seule réserve des contenus fournis par les
          Utilisateurs eux-mêmes, et de la publicité ou des applications fournie
          par des tiers.
        </P>

        <P>
          La Société ou des tiers ayants-droits sont donc seuls titulaires de
          l'ensemble des droits de propriété intellectuelle afférents au
          Service, à son contenu ainsi qu'aux logiciels et bases de données
          assurant son fonctionnement.
        </P>

        <P>
          La Société accorde à l'Utilisateur une licence non exclusive,
          personnelle et non transférable l'autorisant à utiliser le Service,
          ainsi que les données qu'il contient et à titre strictement personnel,
          conformément aux présentes Conditions d'Utilisation et, en
          particulier, conformément à la finalité du Service.
        </P>

        <P>
          Afin de permettre l'utilisation et l'amélioration du Service et
          conformément à la finalité du Service, l'Utilisateur concède à la
          Société une licence non exclusive d'utilisation de son image ainsi que
          du contenu et des données qu'il intègre et/ou met en ligne via le
          Service. En enregistrant son image, ses données, informations et/ou
          contenus sur le Service, chaque Utilisateur accepte qu'ils soient
          diffusés sur ledit Service et accessibles aux Recruteurs concernés.
        </P>

        <P>
          La Société est autorisée à adapter et traduire le contenu des
          Utilisateurs, ainsi qu'à reproduire ces adaptations sur tout support
          numérique, actuel ou futur, stipulé ci-dessus, dans le but de fournir
          le Service, notamment en différentes langues.
        </P>

        <P>
          Cette licence est consentie pour le monde entier et pour la durée du
          contrat liant l'Utilisateur à la Société.
        </P>

        <H3>
          Liens hypertexte
        </H3>

        <P>
          Le Service contient des liens hypertextes vers d'autres sites.
          Cependant, la Société ne peut pas vérifier le contenu des sites ainsi
          visités, et en conséquence n'assume aucune responsabilité de ce fait.
        </P>

        <H3>
          Responsabilité de la Société
        </H3>

        <P>
          La responsabilité de la Société ou des tiers ayant-droits ne saurait
          être engagée en cas d'interruption d'accès au Service du fait
          d'opérations de maintenance, de mises à jour ou d'améliorations
          techniques, ou pour en faire évoluer le contenu et/ou la présentation,
          dès lors que ces interruptions seront signalées et qu'elles
          n'excéderont pas les usages en la matière.
        </P>

        <P>
          En outre, la Société pourra interrompre temporairement ou
          définitivement l'accès au Service, notamment en cas de cessation par
          elle de l'activité en cause, ou en cas de liquidation judiciaire ou
          amiable de la société.
        </P>

        <P>
          Dans toute la mesure permise par la loi applicable et dans la mesure
          ou la Société serait jugée responsable d'un dommage non prévu
          ci-dessus, la responsabilité de la Société sera limitée aux dommages
          certains, directs et établis.
        </P>

        <H3>
          Modifications du Service et garanties
        </H3>

        <P>
          La Société ou des tiers ayants-droits se réservent le droit à tout
          moment de modifier tout ou partie du Service, dans le cadre des
          évolutions de la plateforme.
        </P>

        <P>
          La Société fera ses meilleurs efforts pour maintenir le Service à
          fonctionnalités au moins égales et souscrit à ce titre une obligation
          de moyens. La Société n'est responsable d'aucun dommage direct ou
          indirect, relatif à la perte d'informations ou de données, de revenus
          d'activité et ce à quelque titre que ce soit.
        </P>

        <H3>
          Résiliation
        </H3>

        <P>
          De plein droit, La Société ou des tiers ayants-droits pourront mettre
          un terme à l'accès au Service, en cas de non-respect des présentes
          Conditions d'Utilisation par l'Utilisateur. Dans cette hypothèse, la
          Société notifiera cette suspension à l'Utilisateur par courrier
          électronique, et le mettra en demeure de faire cesser cette violation.
          A l'issue d'un délai de huit (8) jours à compter de cette notification
          restée sans effet, la Société pourra résilier de plein droit le
          contrat, sans formalité et sous réserve des dommages et intérêts
          auxquels elle pourrait prétendre en réparation du préjudice résultant
          pour elle de cette situation en raison de sa cause (le manquement de
          l'Utilisateur).
        </P>

        <H3>
          Modification des CGU
        </H3>

        <P>
          La Société ou des tiers ayants-droits se réserve la possibilité de
          modifier, à tout moment et sans préavis, les présentes conditions
          d'utilisation afin de les adapter aux évolutions du site et/ou de son
          exploitation.
        </P>

        <H3>
          Droit applicable
        </H3>

        <P>
          Les présentes CGU et la politique de confidentialité l'accord total
          entre la Société et l'Utilisateur et définissent l'utilisation du
          Service par l'Utilisateur et prévalent sur tout accord antérieur entre
          la Société et l'Utilisateur.
        </P>

        <P>
          Si une des conditions des présentes était considérée comme nulle,
          caduque ou invalide, les parties acceptent néanmoins que la clause
          litigieuse soit interprétée en tenant compte de la commune intention
          des parties, la nullité d'une des clauses n'ayant aucune incidence sur
          la validité de toute autre clause du contrat.
        </P>

        <P>
          La conclusion, l'interprétation et la validité des présentes
          Conditions d'Utilisation sont régies par le droit français.
        </P>
      </Container>
    </>
  );
};

export default TermsAndConditions;
